import { useCallback, useRef, useEffect } from 'react';

/**
 * Hook personalizado para debounce de funciones/callbacks
 * @param {Function} callback - La función a debounce
 * @param {number} delay - El delay en milisegundos (por defecto 500ms)
 * @returns {Function} La función con debounce aplicado
 */
const useDebouncedCallback = (callback, delay = 500) => {
  const timeoutRef = useRef(null);

  const debouncedCallback = useCallback(
    (...args) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => {
        callback(...args);
      }, delay);
    },
    [callback, delay]
  );

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return debouncedCallback;
};

export default useDebouncedCallback;

